/** Helpers **/
import { callWebservice } from './webserviceCaller';

export default class wsFiltersGroups
{
  constructor(
    loaderID,
    dispatch,
    selectedInstance,
    userId
  ){
    this.loaderID = loaderID;
    this.dispatch = dispatch;    
    this.selectedInstance = selectedInstance;
    this.userId = userId;
  }

  getFiltersGroups = ( 
    callBackFct = null
  ) => 
  {
    this.exec(
      {
        userId: this.userId
      },
      callBackFct,
      'get'
    );
  }

  addFiltersGroup = ( 
    filtersGroupName,
    filtersGroupValue,
    callBackFct = null
  ) => 
  {
    this.exec(
      {
        userId: this.userId,
        filtersGroupName: filtersGroupName,
        filtersGroupValue: filtersGroupValue
      },
      callBackFct,
      'add'
    );
  }
  
  exec = (
    datas, 
    callBackFct = null,
    actionType
  ) => 
  {
    callWebservice( 
      this.loaderID,
      actionType + '-filters-groups',
      actionType + '-filters-groups',
      this.dispatch,
      this.selectedInstance,
      datas,
      callBackFct.function !== null ? {
        function: callBackFct.function,
        params: callBackFct?.params !== undefined ? callBackFct.params : null
      } : null
    );
  }
}